<template>
  <div class="wrapper" v-if="getItem">
    <div class="page page1">
      <div class="top">202006 通路版</div>
      <h2>【&nbsp;買&nbsp;賣&nbsp;契&nbsp;約&nbsp;】</h2>
      <div class="nameBox">
        立契約人 ：賣方
        <span class="name"></span>(以下簡稱甲方)
        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 買方
        <span class="name"></span>(以下簡稱乙方)
        <br />茲經雙方同意訂立買賣契約，議定條件如下：
      </div>
      <ul>
        <li>
          <span class="tit">第一條</span>本契約標的物：
          <div class="li_1_con">
            <ul>
              <li>
                商品名稱：
                <span class="pro">{{getItem.productName}}</span>
              </li>
              <li>
                型號規格：
                <span class="pro">{{getItem.carId}}</span>
              </li>
              <li>
                數&nbsp;&nbsp;量：
                <span class="pro pro_nb">乙</span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <span class="tit">第二條</span>本契約之價金：單價
          <span class="mon">{{getItem.vendor.totalPrice}}</span>元整；總價
          <span class="mon">{{getItem.vendor.totalPrice}}</span>元整。
        </li>
        <li>
          <span class="tit">第三條</span>甲方應於簽約日將標的物交付予乙方，價金之付款方式由雙方議定。
        </li>
        <li>
          <span class="tit">第四條</span>甲方應保證所提供之標的物完全符合第一條所規定之規格式樣，並無減少或滅失其通常之效用。
        </li>
        <li>
          <span class="tit">第五條</span>標的物之規格、數量如有不符或瑕疵，甲方應無條件更換無瑕疵之同功能產品，或負責修復至符合規格功能之狀態。
        </li>
        <li>
          <span class="tit">第六條</span>乙方未依約給付價金，甲方除得請求所欠價金外，亦得解除契約，請求乙方返還標的物。乙方已付價金並應作為賠償甲方之損失，不得請求返還。
        </li>
        <li>
          <span class="tit">第七條</span>本契約之解釋、效力及其他未盡事宜，皆以相關法律為準則。倘有任何糾紛，雙方亦應依誠實信用原則解決。如有訴訟必要，雙方同意以
          <u>臺灣臺北地方法院</u>為第一審管轄法院。
        </li>
        <li>
          <span class="tit">第八條</span>本契約一式二份，由甲乙雙方各執一份為憑。
        </li>
      </ul>
      <div class="bt">
        立契約人
        <br />
        <div class="bt_left">
          甲方即賣方：
          <div class="add">
            地&nbsp;&nbsp;&nbsp;址：
            <div></div>
          </div>
        </div>
        <div class="bt_right">
          乙方即買方：
          <br />
          <div class="add">
            地&nbsp;&nbsp;&nbsp;址：
            <div></div>
          </div>
        </div>
      </div>
      <!--end of bt-->
      <div class="date">
        中華民國
        <span class="d d1"></span>&nbsp;年
        <span class="d d2"></span>&nbsp;月
        <span class="d d3"></span>&nbsp;日
      </div>
    </div>
    <!--page1-->
  </div>
  <!--wrapper-->
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Contract",
  data() {
    return {
      item: null,
      status: false,
    };
  },
  created() {
    const caseId = this.$route.query.caseId;
    this.status = parseInt(this.$route.query.caseCategory, 10);
    if (caseId) {
      this.fetchFinanceCreditInfo({ caseId }).then((results) => {
        if (results.length) {
          this.item = results[0];
          console.log(`fetchFinanceCreditInfo ${JSON.stringify(this.item)}`);
        }
      });
    }
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    getItem() {
      return this.item;
    },
    getCreateDate() {
      return new Date(this.getItem.createDate);
    },
  },
  methods: {
    ...mapActions(["fetchFinanceCreditInfo"]),
  },
};
</script>

<style scoped src="../../assets/css/contract.css">
</style>



// WEBPACK FOOTER //
// src/pages/web/Contract.vue